const {comparableProducts, PREPARATION, escapeHtml} = await import((typeof window !== 'undefined' && window.HG_ASSETS?.['comparison-model.js']) || new URL('./hg12-comparison-model.js', import.meta.url).href);

const ALTERNATIVES = Object.freeze({
  roaster:'rosebud', rosebud:'colombia', colombia:'rosebud',
  masala:'cardamom', cardamom:'masala', nola:'roaster'
});
const LESSON_LABELS = Object.freeze({
  coffee:'Coffee brewing basics', chai:'Making chai at home', cold:'Mixing your concentrate'
});

// These are routes into existing help, not new recipes or product claims.
export function productHelpLinks(id, products = []) {
  const eligible = comparableProducts(products);
  const product = eligible.find(item => item.id === id);
  if (!product) return null;
  const lesson = PREPARATION[id].lesson;
  const alternative = eligible.find(item => item.id === ALTERNATIVES[id]) || eligible.find(item => item.id !== id);
  return {
    learn:{href:`journal.html?lesson=${encodeURIComponent(lesson)}#brew-guide`, label:LESSON_LABELS[lesson]},
    compare:alternative ? {
      href:`shop.html?compare=${encodeURIComponent(`${id},${alternative.id}`)}#compare-favorites`,
      label:`Compare with ${alternative.name}`
    } : null
  };
}

export function productHelpMarkup(links) {
  if (!links) return '';
  const link = item => `<a href="${escapeHtml(item.href)}"><span>${escapeHtml(item.label)}</span><span class="hg-arrow hg-arrow--right" aria-hidden="true"></span></a>`;
  return `<nav class="p-home-help" id="product-home-help" aria-labelledby="p-home-help-title"><h2 id="p-home-help-title">Preparation &amp; comparison</h2>${link(links.learn)}${links.compare ? link(links.compare) : ''}</nav>`;
}

export function initProductHelp(doc = document, browser = window) {
  const adapt = browser.HGMarkup || (value => value);
  if (doc.body.dataset.page !== 'product' || doc.getElementById('product-home-help')) return null;
  const handle = browser.location.pathname?.match(/\/products\/([^/?#]+)/)?.[1];
  const id = new URLSearchParams(browser.location.search).get('id') || browser.HG_DATA?.products?.find(item => item.handle === handle)?.id;
  const links = productHelpLinks(id, browser.HG_DATA?.products);
  if (!links) return null;
  const handoff = doc.querySelector('.j-detail-copy > .j-small') || doc.querySelector('.product__info-container product-form') || doc.querySelector('.product__info-container');
  if (!handoff) return null;
  const markup = adapt(productHelpMarkup(links));
  const native = handoff.matches?.('product-form, .product__info-container');
  handoff.insertAdjacentHTML(handoff.matches?.('.product__info-container') ? 'beforeend' : 'afterend', native ? '<div class="hg-v12-root">' + markup + '</div>' : markup);
  return links;
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initProductHelp(), {once:true});
  else initProductHelp();
}
